import {
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  HStack,
  Heading,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  Text,
} from '@mybridge/ui';
import { forwardRef, useContext } from 'react';
import { DiskContext } from '../context';
import { useForm } from 'react-hook-form';
import { FileFolderIcon } from '../my-disk/file-icon';
import { isFile } from 'v4/components/utils';
import { getFullFileName } from 'v4/lib/commons';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { useDirection } from '@mybridge/ui/custom-hooks/useDirection';

export const DiskDownloadFileModal = forwardRef(({ ...props }, ref) => {
  const {
    downloadDisc,
    downloadFileFolder,
    downloadFileFolderLoading,
    selectedFile,
  } = useContext(DiskContext);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  
  const onSubmit = () => {
    downloadFileFolder(selectedFile);
  };
  
  const { t } = useTranslator();
  const direction = useDirection();
  
  return (
    <>
      <Modal isCentered {...downloadDisc}>
        <ModalOverlay />
        <ModalContent>
          <ModalCloseButton {...(direction === 'rtl') ? {left: '0.75rem', right: 'auto'} : {left: 'auto', right: '0.75rem'}} />
          <ModalHeader>
            <HStack alignItems={'flex-start'}>
              <Stack spacing={0} gap={0}>
                <Heading size="md">
                  {t('profilePhotosVideos.download') || "Download"} {isFile(selectedFile) ? (t('otherModules.file') || 'File') : (t('myDisk.folder') || 'Folder')}
                </Heading>
              </Stack>
            </HStack>
          </ModalHeader>
          <ModalBody>
            <Text noOfLines={2}>
              {"Are you sure you want to download"}{' '}
              <Text display="inline" fontWeight="bold">
                "{getFullFileName(selectedFile)}"
              </Text>
              ?
            </Text>
          </ModalBody>
          <ModalFooter>
            <HStack>
              <Button borderRadius="30px" onClick={downloadDisc?.onClose} variant="secondary">
                {t('buttons.cancel') || "Cancel"}
              </Button>
              <Button
                variant={'primary'}
                borderRadius="30px"
                isLoading={downloadFileFolderLoading}
                onClick={onSubmit}
                colorScheme="blue"
              >
                {t('myDisk.download') || "Download"}
              </Button>
            </HStack>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
});